import { css } from "@emotion/react";

export const container = css`
  padding-top: 48px;
  padding-bottom: 48px;
  width: 100%;
`;

export const wwLogo = css`
  text-align: left;
`;

export const links = css`
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 32px 16px;
`;

export const downloadLinks = css`
  grid-area: download;
  display: flex;
`;

export const appIcon = css`
  grid-area: icon;
  max-width: 40px;
  @media (min-width: 600px) {
    max-width: 56px;
  }
`;

export const appstore = css`
  margin-left: 16px;
  max-width: 109px;
  @media (min-width: 600px) {
    margin-left: 32px;
    max-width: 152px;
  }
`;

export const googleplay = css`
  margin-left: 11px;
  max-width: 135px;
  @media (min-width: 600px) {
    max-width: 189px;
    margin-left: 16px;
  }
`;
export const twitter = css`
  grid-area: twitter;
  align-self: flex-end;
  width: 32px;
  margin-left: auto;
  :hover {
    opacity: 0.8;
    transition: all 0.5s;
  }
`;
